import React, { useState } from "react";
import AMRPreReviewPrescriptionSection from "./AMRPreReviewPrescriptionSection";
import AMRPreReviewAdditionalMedicationsSection from "./AMRPreReviewAdditionalMedicationsSection";

const AMRPreReviewView = ({
  filteredMedication,
  reviewedMedicationCards,
  onMedicationClick,
  onMenuAction,
  onExpandMedication,
  expandedMedications,
  hoveredMed,
  onMouseEnter,
  onMouseLeave,
  menuMedication,
  onMenuOpen,
  showMenu,
  menuData,
  selectedMedication,
  isMatchingDrug,
  medicationDetails,
  getNoRecordMessage,
  getCardFromDrug,
  selectMedication,
  defaultExpandedSection = null,
  medications = [],
  clinicalServiceObj = null,
}) => {
  // Accordion state for AMR Pre-Review sections
  const [expandedSection, setExpandedSection] = useState(defaultExpandedSection);

  // Toggle functions for each section
  const handlePrescriptionToggle = () => {
    if (expandedSection === 'prescription') {
      setExpandedSection(null);
    } else {
      setExpandedSection('prescription');
    }
  };

  const handleAdditionalToggle = () => {
    if (expandedSection === 'additional') {
      setExpandedSection(null);
    } else {
      setExpandedSection('additional');
    }
  };

  // Render sections with accordion logic
  const renderMedicationSections = () => {
    const sections = [];

    // Add collapsed sections first
    if (expandedSection !== 'prescription') {
      sections.push(
        <AMRPreReviewPrescriptionSection
          key="prescription-collapsed"
          filteredMedication={filteredMedication}
          reviewedMedicationCards={reviewedMedicationCards}
          showPrescriptionMeds={false}
          setShowPrescriptionMeds={handlePrescriptionToggle}
          onMedicationClick={onMedicationClick}
          onMenuAction={onMenuAction}
          onExpandMedication={onExpandMedication}
          expandedMedications={expandedMedications}
          hoveredMed={hoveredMed}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          menuMedication={menuMedication}
          onMenuOpen={onMenuOpen}
          showMenu={showMenu}
          menuData={menuData}
          selectedMedication={selectedMedication}
          isMatchingDrug={isMatchingDrug}
          medicationDetails={medicationDetails}
          getNoRecordMessage={getNoRecordMessage}
          getCardFromDrug={getCardFromDrug}
          selectMedication={selectMedication}
          medications={medications}
        />
      );
    }

    if (expandedSection !== 'additional') {
      sections.push(
        <AMRPreReviewAdditionalMedicationsSection
          key="additional-collapsed"
          filteredMedication={filteredMedication}
          reviewedMedicationCards={reviewedMedicationCards}
          showAdditionalMeds={false}
          setShowAdditionalMeds={handleAdditionalToggle}
          onMedicationClick={onMedicationClick}
          onMenuAction={onMenuAction}
          onExpandMedication={onExpandMedication}
          expandedMedications={expandedMedications}
          hoveredMed={hoveredMed}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          menuMedication={menuMedication}
          onMenuOpen={onMenuOpen}
          showMenu={showMenu}
          menuData={menuData}
          selectedMedication={selectedMedication}
          isMatchingDrug={isMatchingDrug}
          medicationDetails={medicationDetails}
          getNoRecordMessage={getNoRecordMessage}
          getCardFromDrug={getCardFromDrug}
          selectMedication={selectMedication}
          medications={medications}
          clinicalServiceObj={clinicalServiceObj}
        />
      );
    }

    // Add expanded section at the end
    if (expandedSection === 'prescription') {
      sections.push(
        <AMRPreReviewPrescriptionSection
          key="prescription-expanded"
          filteredMedication={filteredMedication}
          reviewedMedicationCards={reviewedMedicationCards}
          showPrescriptionMeds={true}
          setShowPrescriptionMeds={handlePrescriptionToggle}
          onMedicationClick={onMedicationClick}
          onMenuAction={onMenuAction}
          onExpandMedication={onExpandMedication}
          expandedMedications={expandedMedications}
          hoveredMed={hoveredMed}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          menuMedication={menuMedication}
          onMenuOpen={onMenuOpen}
          showMenu={showMenu}
          menuData={menuData}
          selectedMedication={selectedMedication}
          isMatchingDrug={isMatchingDrug}
          medicationDetails={medicationDetails}
          getNoRecordMessage={getNoRecordMessage}
          getCardFromDrug={getCardFromDrug}
          selectMedication={selectMedication}
          medications={medications}
        />
      );
    }

    if (expandedSection === 'additional') {
      sections.push(
        <AMRPreReviewAdditionalMedicationsSection
          key="additional-expanded"
          filteredMedication={filteredMedication}
          reviewedMedicationCards={reviewedMedicationCards}
          showAdditionalMeds={true}
          setShowAdditionalMeds={handleAdditionalToggle}
          onMedicationClick={onMedicationClick}
          onMenuAction={onMenuAction}
          onExpandMedication={onExpandMedication}
          expandedMedications={expandedMedications}
          hoveredMed={hoveredMed}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          menuMedication={menuMedication}
          onMenuOpen={onMenuOpen}
          showMenu={showMenu}
          menuData={menuData}
          selectedMedication={selectedMedication}
          isMatchingDrug={isMatchingDrug}
          medicationDetails={medicationDetails}
          getNoRecordMessage={getNoRecordMessage}
          getCardFromDrug={getCardFromDrug}
          selectMedication={selectMedication}
          medications={medications}
          clinicalServiceObj={clinicalServiceObj}
        />
      );
    }

    return sections;
  };

  return (
    <div className="space-y-0">
      {renderMedicationSections()}
    </div>
  );
};

export default AMRPreReviewView;
